var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", {
    directives: [
      { name: "show", rawName: "v-show", value: false, expression: "false" },
    ],
    staticClass: "sug_wraper",
    attrs: { id: "sug_wraper" },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }